import React, { useState } from 'react';
import { useAppContext } from '../../../../Services/AppContext';
import PatientManualRegistrationCzech from './Czech/PatientManualRegistrationCzech';
import PatientManualRegistrationSlovakia from './Slovakia/PatientManualRegistrationSlovakia';
import PatientManualRegistrationLatam from './Latam/PatientManualRegistrationLatam';
import PatientManualRegistrationMOU from './Czech/MOU/PatientManualRegistrationMOU';
import OverlayLoading from '../../../../Components/OverlayLoading';
import useScope from '../../../Scope/Hooks/useScope';
import PatientManualRegistrationKDAR from './Czech/KDAR/PatientManualRegistrationKDAR';
import PatientManualRegistrationHungary from './Hungary/PatientManualRegistrationHungary';
import PatientManualRegistrationPoland from './Poland/PatientManualRegistrationPoland';
import PatientManualRegistrationSlovenia from './Slovenia/PatientManualRegistrationSlovenia';
import PatientManualRegistrationSerbia from './Serbia/PatientManualRegistrationSerbia';

interface Props {
	workplaceId: string;
	onSuccess: (params: PatientManualRegistrationParams) => void;
}

export interface PatientManualRegistrationParams {
	patientId: string;
	withInvite: boolean;
	parentId: string | null;
	ignoreActions?: boolean;
}

const PatientManualRegistration: React.FC<Props> = ({
	workplaceId,
	onSuccess,
}) => {
	const { globalTemplate, isMou } = useAppContext();
	const [isLoading, setIsLoading] = useState(false);
	const { isKDARWorkplace } = useScope();

	let component;

	switch (globalTemplate) {
		case 'peru':
		case 'ecuador':
		case 'mexico':
		case 'colombia':
			component = (
				<PatientManualRegistrationLatam
					workplaceId={workplaceId}
					onSuccess={onSuccess}
					setIsLoading={setIsLoading}
				/>
			);
			break;
		case 'slovakia':
			component = (
				<PatientManualRegistrationSlovakia
					workplaceId={workplaceId}
					onSuccess={onSuccess}
					setIsLoading={setIsLoading}
				/>
			);
			break;
		case 'hungary':
			component = (
				<PatientManualRegistrationHungary
					workplaceId={workplaceId}
					onSuccess={onSuccess}
					setIsLoading={setIsLoading}
				/>
			);
			break;
		case 'poland':
			component = (
				<PatientManualRegistrationPoland
					workplaceId={workplaceId}
					setIsLoading={setIsLoading}
					onSuccess={onSuccess}
				/>
			);
			break;
		case 'slovenia':
			component = (
				<PatientManualRegistrationSlovenia
					workplaceId={workplaceId}
					setIsLoading={setIsLoading}
					onSuccess={onSuccess}
				/>
			);
			break;
		case 'serbia':
			component = (
				<PatientManualRegistrationSerbia
					workplaceId={workplaceId}
					setIsLoading={setIsLoading}
					onSuccess={onSuccess}
				/>
			);
			break;
		default:
		case 'czechia':
			if (isMou) {
				component = (
					<PatientManualRegistrationMOU
						onSuccess={onSuccess}
						setIsLoading={setIsLoading}
					/>
				);
				break;
			}
			if (isKDARWorkplace) {
				component = (
					<PatientManualRegistrationKDAR
						setIsLoading={setIsLoading}
						workplaceId={workplaceId}
					/>
				);
				break;
			}
			component = (
				<PatientManualRegistrationCzech
					workplaceId={workplaceId}
					onSuccess={onSuccess}
					setIsLoading={setIsLoading}
				/>
			);
			break;
	}

	return (
		<>
			{isLoading && <OverlayLoading />}
			{component}
		</>
	);
};

export default PatientManualRegistration;
